import gql from "graphql-tag";

export default gql`
	mutation updateWorkflow($id: ID, $update: Update, $parentId: ID) {
		workflow(id: $id, update: $update, parentId: $parentId)
	}
`;
